import React,{useState,useEffect} from 'react';
import Modal from './Modal';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from "react-i18next";
import Typography from '@material-ui/core/Typography';
import { Grid } from "@material-ui/core";
import DateFnsUtils from '@date-io/date-fns';
import { KeyboardTimePicker, KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import moment from 'moment';
import { properCase, isDateValid } from "utils";
import { AccessTime as Watch, DateRange, Close } from "@material-ui/icons";
import {
  dateConfig,
} from "../../../../config/index";
import {isNumericOnly} from "../../../../utils/validations";

const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiTextField-root': {
      margin: theme.spacing(1),
      width: '25ch',
    },
  },
  textField:{
    width:'100%',
    //margin:"10px 0"
  },
  punchdetailCont:{
    display:'flex',
    alignItems:"center",
    color:"rgb(0 0 0 / 54%)",
    fontWeight:400,
    fontSize:"14px"
  }
}));


const TransportDetailsModal = (props) =>{

  const {selectedTripPunch,loggedInUser} = props;
  const classes = useStyles();
  const { t } = useTranslation();
  const [saveBtnDisabled, setSaveBtnDisabled] = useState(true);
  const [startDate, setStartDate] = useState(new Date());
  const [startTime, setStartTime] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [endTime, setEndTime] = useState(new Date());
  const [routeId, setRouteId] = useState("");
  const [startOdometer, setStartOdomter] = useState("");
  const [endOdometer, setEndOdometer] = useState("");
  const [endTimeErr, setEndTimeErr] = useState(false);
  const [endDateErr, setEndDateErr] = useState(false);
  const [punchIn, setPunchIn] = useState("");
  const [punchOut, setPunchOut] = useState("");
  const [minDate, setMinDate] = useState(new Date());
  const [maxDate, setMaxDate] = useState(new Date());

  useEffect(()=>{
       if(routeId && routeId.trim() !== "" && startOdometer && startOdometer.trim() !== "" &&
        endOdometer && endOdometer.trim() !== "" && !(Number(endOdometer)<=Number(startOdometer))
        && startDate && endDate && startTime && endTime && isDateValid(startDate) && isDateValid(endDate)
        && isDateValid(startTime)&& isDateValid(endTime) && !endDateErr && !endTimeErr &&
        (routeId.trim() !== selectedTripPunch.routeId.trim() ||
         startOdometer.toString() !==selectedTripPunch?.startOdometer?.toString() ||
         endOdometer.toString() !== selectedTripPunch?.endOdometer?.toString() ||
         moment(selectedTripPunch?.startTripLocalTS).format("hhmm") != moment(startTime).format("hhmm") ||
         moment(selectedTripPunch?.endTripLocalTS).format("hhmm") != moment(endTime).format("hhmm") ||
         moment(selectedTripPunch?.startTripLocalTS).format("DDMMYYYY") != moment(startDate).format("DDMMYYYY") ||
         moment(selectedTripPunch?.endTripLocalTS).format("DDMMYYYY") !=moment(endDate).format("DDMMYYYY") 
        )
        ){
        setSaveBtnDisabled(false);
       }else{
        setSaveBtnDisabled(true);
       }
   },[ routeId, startOdometer, endOdometer, startDate , endDate ,startTime , endTime, endDateErr,endTimeErr])

   useEffect(() => {
    if(Object.keys(selectedTripPunch).length>0){
      selectedTripPunch.routeId ? setRouteId(selectedTripPunch.routeId) : setRouteId("");
      selectedTripPunch.startOdometer ? setStartOdomter(selectedTripPunch.startOdometer.toString()) : setStartOdomter("");
      selectedTripPunch.endOdometer ? setEndOdometer(selectedTripPunch.endOdometer.toString()):setEndOdometer("");
      selectedTripPunch.startTripLocalTS ? setStartDate(new Date(selectedTripPunch.startTripLocalTS)):setStartDate(new Date());
      selectedTripPunch.endTripLocalTS ? setEndDate(new Date(selectedTripPunch.endTripLocalTS)):setEndDate(new Date());
      selectedTripPunch.startTripLocalTS ? setStartTime(new Date(selectedTripPunch.startTripLocalTS)):setStartTime(new Date());
      selectedTripPunch.endTripLocalTS ? setEndTime(new Date(selectedTripPunch.endTripLocalTS)):setEndTime(new Date());
      selectedTripPunch.inLocalTS ? setPunchIn(moment(selectedTripPunch.inLocalTS).format("DD/MM HH:mm")): setPunchIn("");
      selectedTripPunch.outLocalTS ? setPunchOut(moment(selectedTripPunch.outLocalTS).format("DD/MM HH:mm")): setPunchOut("");
      if(selectedTripPunch.endTripLocalTS){
         setMinDate(moment(selectedTripPunch.endTripLocalTS).startOf('week'));
         setMaxDate(moment(selectedTripPunch.endTripLocalTS).endOf('week'));
      }else if(selectedTripPunch.startTripLocalTS){
        setMinDate(moment(selectedTripPunch.startTripLocalTS).startOf('week'));
        setMaxDate(moment(selectedTripPunch.startTripLocalTS).endOf('week'));
      }else if (selectedTripPunch.inLocalTS){
        setMinDate(moment(selectedTripPunch.inLocalTS).startOf('week'));
        setMaxDate(moment(selectedTripPunch.inLocalTS).endOf('week'));
      }
    }
   },[selectedTripPunch])

   useEffect(() => {
    endDate && isDateValid(endDate) && startDate && moment(endDate).startOf("day") >= moment(startDate).startOf("day")?
    setEndDateErr(false):setEndDateErr(true);

    let _inLocalTS = "";
    let _outLocalTS = "";
    if(startDate && endDate && startTime && endTime){
      _inLocalTS = startDate ? new Date(
        startDate.getFullYear(),
        startDate.getMonth(),
        startDate.getDate(),
        startTime.getHours(),
        startTime.getMinutes(),
        startTime.getSeconds(),
        startTime.getMilliseconds()
      ).toString():"";
  
      _outLocalTS = endDate? new Date(
        endDate.getFullYear(),
        endDate.getMonth(),
        endDate.getDate(),
        endTime.getHours(),
        endTime.getMinutes(),
        endTime.getSeconds(),
        endTime.getMilliseconds()
      ).toString():"";
    }
    
    
    (endTime && !isDateValid(endTime)) 
    || (startDate && endDate && startTime && _inLocalTS>_outLocalTS) 
     ?
    setEndTimeErr(true) : setEndTimeErr(false);

   },[endDate, endTime, startDate, startTime])

   const onOkClicked = () =>{
    let startDateStr = new Date(startDate);
      let startDateTime = new Date(startTime);
      let endDateStr = new Date(endDate);
      let endDateTime = new Date(endTime);
    const inTS = new Date(
      startDateStr.getFullYear(),
      startDateStr.getMonth(),
      startDateStr.getDate(),
      startDateTime.getHours(),
      startDateTime.getMinutes(),
      startDateTime.getSeconds(),
      startDateTime.getMilliseconds()
    ).toISOString();

    const _inLocalTS = new Date(
      startDateStr.getFullYear(),
      startDateStr.getMonth(),
      startDateStr.getDate(),
      startDateTime.getHours(),
      startDateTime.getMinutes(),
      startDateTime.getSeconds(),
      startDateTime.getMilliseconds()
    ).toString();

    const inLocalTS = moment(_inLocalTS).format(dateConfig.format4);

    const outTS = new Date(
      endDateStr.getFullYear(),
      endDateStr.getMonth(),
      endDateStr.getDate(),
      endDateTime.getHours(),
      endDateTime.getMinutes(),
      endDateTime.getSeconds(),
      endDateTime.getMilliseconds()
    ).toISOString();

    const _outLocalTS = new Date(
      endDateStr.getFullYear(),
      endDateStr.getMonth(),
      endDateStr.getDate(),
      endDateTime.getHours(),
      endDateTime.getMinutes(),
      endDateTime.getSeconds(),
      endDateTime.getMilliseconds()
    ).toString();

    const outLocalTS = moment(_outLocalTS).format(dateConfig.format4);
      let editedPunch = {
        routeId:routeId,
        startOdometer:startOdometer.toString(),
        endOdometer:endOdometer.toString(),
        startTripLocalTS:inLocalTS,
        startTripTS:inTS,
        endTripLocalTS:outLocalTS,
        endTripTS:outTS,
        mileage:Number(endOdometer) - Number(startOdometer),
        actionTS:new Date().toISOString()
      }
      if(selectedTripPunch.inTrip){
        editedPunch.inTrip = false;
      }
      if(loggedInUser && loggedInUser.workerId){
        editedPunch.actionBy = loggedInUser.workerId;
      }
      console.log("editedPunch", editedPunch, selectedTripPunch)
      props.onSave && props.onSave(editedPunch);
      setSaveBtnDisabled(true);
   }

return (
  <>
  <Modal
    title={t("other.txtTransportTripDialogTitle")}
    subTitle = {`${selectedTripPunch.name} (${selectedTripPunch.workerId})`}
    isOpen={props.open}
    onCancel={()=>{
      props.onCancel && props.onCancel();
    }}
    onOk={onOkClicked}
    okDisabled={saveBtnDisabled}
    punchIn={punchIn}
    punchOut = {punchOut}
  >
     <Grid container spacing={2}>
        <Grid item md={6} xs={12} sm={12} lg={6} xl={6}>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                  placeholder="dd/MM/yyyy"
                  margin="none"
                  id="date-picker-dialog"
                  format="dd/MM/yyyy"
                  value={startDate}
                  onChange={(newValue) => {
                    setStartDate(newValue)
                  }}
                  minDate={minDate}
                  maxDate={maxDate}
                  inputVariant="outlined"
                  size="small"
                  label={t("pgReview.tableHeads.startDate")}
                  keyboardIcon={<DateRange fontSize="inherit" />}
                   error={startDate && !isDateValid(startDate)}
                   helperText={""}
                />
                </MuiPickersUtilsProvider>
              </Grid>
              <Grid item md={6} xs={12} sm={12} lg={6} xl={6}>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                  placeholder="dd/MM/yyyy"
                  margin="none"
                  id="date-picker-dialog"
                  format="dd/MM/yyyy"
                  value={endDate}
                  onChange={(newValue) => {
                    setEndDate(newValue)
                  }}
                  minDate={minDate}
                  maxDate={maxDate}
                  inputVariant="outlined"
                  size="small"
                  label={t("pgReview.tableHeads.endDate")}
                  keyboardIcon={<DateRange fontSize="inherit" />}
                   error={endDateErr}
                   helperText={endDateErr? t("other.endDateError"):""}
                />
                </MuiPickersUtilsProvider>
              </Grid>
              <Grid item md={6} xs={12} sm={12} lg={6} xl={6}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardTimePicker
                  ampm={false}
                  disableBackdropClick
                  placeholder="hh:mm"
                  margin="none"
                  id="date-picker-dialog"
                  // format="hh:mm a"
                  value={startTime}
                  onChange={(newValue) => {
                    setStartTime(newValue);
                  }}
                  inputVariant="outlined"
                  size="small"
                  label={properCase(t("pgReview.tableHeads.startTime"))}
                  keyboardIcon={<Watch fontSize="inherit" />}
                   error={startTime && !isDateValid(startTime)}
                   helperText={""}
                />
                 </MuiPickersUtilsProvider>
              </Grid>
              <Grid item md={6} xs={12} sm={12} lg={6} xl={6}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardTimePicker
                  ampm={false}
                  disableBackdropClick
                  placeholder="hh:mm"
                  margin="none"
                  id="date-picker-dialog"
                  // format="hh:mm a"
                  value={endTime}
                  onChange={(newValue) => {
                    setEndTime(newValue);
                  }}
                  inputVariant="outlined"
                  size="small"
                  label={properCase(t("pgReview.tableHeads.endTime"))}
                  keyboardIcon={<Watch fontSize="inherit" />}
                  // error={(endTime &&!isDateValid(endTime)) || 
                  //   (startDate && endDate && startDate.toDateString() == endDate.toDateString() &&
                  //    startTime && endTime && startTime.valueOf()>endTime.valueOf())}
                  // helperText={startDate && endDate && startDate.toDateString() == endDate.toDateString() && 
                  //   startTime && endTime && startTime.valueOf()>endTime.valueOf() ?
                  // t("other.endTimeError"):""}
                  error = {endTimeErr}
                  helperText = {endTimeErr?t("other.endTimeError"):""}
                />
                 </MuiPickersUtilsProvider>
              </Grid>
      <Grid item md={6} xs={12} sm={12} lg={6} xl={6}>
        <TextField
          id="startOdometer"
          label={t("other.lblStartOdometer")}
          value={startOdometer}
          onChange = {(event) => {
            console.log("value", event.target.value);
            let value = event.target.value;
            if(isNumericOnly(value)){
              setStartOdomter(value)
             }
          }}
          //helperText="Some important text"
          variant="outlined"
          className={classes.textField}
          size="small"
        />
      </Grid>
      <Grid item md={6} xs={12} sm={12} lg={6} xl={6}>
        <TextField
          id="endOdometer"
          label={t("other.lblEndOdometer")}
          value={endOdometer}
          onChange = {(event) => {
            console.log("value", event.target.value);
            let value = event.target.value;
            if(isNumericOnly(value)){
              setEndOdometer(value)
             }
          }}
          helperText={
            endOdometer !="" && Number(endOdometer)<=Number(startOdometer) ? t("other.mileageErrorMsg"):""
          }
          variant="outlined"
          className={classes.textField}
          error = { endOdometer !="" && Number(endOdometer)<=Number(startOdometer)}
          size="small"
        />
        </Grid>
        <Grid item md={6} xs={12} sm={12} lg={6} xl={6}>
        <TextField
          id="routeId"
          label={t("other.lblrouteId")}
          value={routeId}
          onChange = {(event) => {
            console.log("value", event.target.value);
            let value = event.target.value;
            if(value.trim().length>0){
              setRouteId(value)
             }else{
              setRouteId("")
             }
          }}
          //helperText="Some important text"
          variant="outlined"
          className={classes.textField}
          size="small"
        />
      </Grid>
        </Grid>
  </Modal>
  </>
)
};

export default TransportDetailsModal;